var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper chat-timing-settings" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.chatTimingSettings"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("settings.chatTimingSettingsSubtitles"))),
        ]),
      ]),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          { staticClass: "features" },
          _vm._l(_vm.features, function (feature) {
            return _c("FeatureItem", {
              key: feature.id,
              attrs: {
                value: _vm.readValue(feature.id),
                title: feature.title,
                description: feature.description,
                type: "number",
                min: feature.min,
                max: feature.max,
                step: feature.step,
                icon: feature.icon,
              },
              on: {
                input: function ($event) {
                  return _vm.setValue(feature.id, $event)
                },
              },
            })
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }